// Two-factor sign-in for console staff (#227): sign-in steps, Profile, the banner, and staff and account resets.
export const twoFactorEn = {
  'auth.2fa.codeTitle': 'Two-step verification',
  'auth.2fa.codeSubtitle': 'Enter the 6-digit code from your authenticator app.',
  'auth.2fa.code': 'Code',
  'auth.2fa.codeHint': 'Lost your phone? Enter one of your recovery codes instead.',
  'auth.2fa.verify': 'Verify',
  'auth.2fa.verifying': 'Checking…',
  'auth.2fa.wrongCode': 'Wrong code. Try again.',
  'auth.2fa.expired': 'This sign-in has expired. Sign in again.',
  'auth.2fa.locked': 'Too many attempts. Try again in 15 minutes.',
  'auth.2fa.startOver': 'Start over',
  'auth.2fa.setupTitle': 'Set up two-step verification',
  'auth.2fa.setupRequired': 'Your account needs a code from your phone at every sign-in. Set it up now to continue.',
  'auth.2fa.setupIntro': 'Scan this QR code with an authenticator app (for example Google Authenticator, Microsoft Authenticator or 1Password), then enter the 6-digit code it shows.',
  'auth.2fa.qr': 'QR code for your authenticator app',
  'auth.2fa.manualKey': 'Can’t scan? Enter this key in the app:',
  'auth.2fa.turnOn': 'Turn on',
  'auth.2fa.working': 'Saving…',
  'auth.2fa.recoveryTitle': 'Save your recovery codes',
  'auth.2fa.recoveryIntro': 'If you lose your phone, each code signs you in once. They are shown only now: copy or download them and keep them somewhere safe.',
  'auth.2fa.copy': 'Copy',
  'auth.2fa.copied': 'Copied',
  'auth.2fa.download': 'Download',
  'auth.2fa.saved': 'I saved them, continue',
  'auth.2fa.panelTitle': 'Two-step verification',
  'auth.2fa.panelHint': 'A code from your phone at every sign-in, on top of your password.',
  'auth.2fa.statusOn': 'On · {count} recovery codes left',
  'auth.2fa.statusOff': 'Off',
  'auth.2fa.statusRequired': 'Required for all console staff.',
  'auth.2fa.setUp': 'Set up',
  'auth.2fa.turnOff': 'Turn off',
  'auth.2fa.turnOffHint': 'Enter a current code or a recovery code to turn it off. Moving to a new phone? Turn it off, then set it up again.',
  'auth.2fa.turnedOn': 'Two-step verification is on.',
  'auth.2fa.turnedOff': 'Two-step verification is off.',
  'auth.2fa.cancel': 'Cancel',
  'auth.2fa.banner': 'Two-step verification will soon be required for all console staff. Set it up now: it takes a minute.',
  'auth.2fa.bannerAction': 'Set it up',
  'staff.2fa.on': '2-step on',
  'staff.2fa.reset': 'Reset 2-step',
  'staff.2fa.resetTitle': 'Reset two-step verification for {name}?',
  'staff.2fa.resetBody': 'Their authenticator app and recovery codes stop working. They set it up again at their next sign-in.',
  'staff.2fa.resetDone': 'Two-step verification reset.',
  'staff.central.title': 'Digimasi accounts: reset two-step verification',
  'staff.central.hint': 'For someone who signs in at admin.digimasi.com and lost their phone and recovery codes. A website’s own admin can’t reset it when the person also uses another Digimasi website; you can, here. Check who you are talking to first.',
  'staff.central.email': 'Email of the Digimasi account',
  'staff.central.submit': 'Reset two-step verification',
  'staff.central.confirmTitle': 'Reset two-step verification for {email}?',
  'staff.central.confirmBody': 'Their authenticator app and recovery codes stop working on every Digimasi website. They set it up again at their next sign-in.',
  'staff.central.done': 'Reset. {email} sets it up again at the next sign-in.',
  'staff.central.nothing': '{email} had no two-step verification. Nothing changed.',
  'audit.action.auth.login_password': 'Password accepted, code next',
  'audit.action.auth.2fa_failed': 'Wrong two-step code',
  'audit.action.auth.2fa_recovery_used': 'Signed in with a recovery code',
  'audit.action.auth.2fa_setup': 'Turned on two-step verification',
  'audit.action.auth.2fa_disabled': 'Turned off two-step verification',
  'audit.action.staff.2fa_reset': 'Reset a staff member’s two-step verification',
  'audit.action.account.2fa_reset': 'Reset a Digimasi account’s two-step verification',
} as const

export const twoFactorId: Record<keyof typeof twoFactorEn, string> = {
  'auth.2fa.codeTitle': 'Verifikasi dua langkah',
  'auth.2fa.codeSubtitle': 'Masukkan kode 6 digit dari aplikasi autentikator Anda.',
  'auth.2fa.code': 'Kode',
  'auth.2fa.codeHint': 'HP hilang? Masukkan salah satu kode pemulihan Anda.',
  'auth.2fa.verify': 'Verifikasi',
  'auth.2fa.verifying': 'Mengecek…',
  'auth.2fa.wrongCode': 'Kode salah. Coba lagi.',
  'auth.2fa.expired': 'Proses masuk ini sudah kedaluwarsa. Silakan masuk lagi.',
  'auth.2fa.locked': 'Terlalu banyak percobaan. Coba lagi dalam 15 menit.',
  'auth.2fa.startOver': 'Ulangi dari awal',
  'auth.2fa.setupTitle': 'Aktifkan verifikasi dua langkah',
  'auth.2fa.setupRequired': 'Akun Anda perlu kode dari HP setiap kali masuk. Aktifkan sekarang untuk lanjut.',
  'auth.2fa.setupIntro': 'Pindai kode QR ini dengan aplikasi autentikator (misalnya Google Authenticator, Microsoft Authenticator, atau 1Password), lalu masukkan kode 6 digit yang muncul.',
  'auth.2fa.qr': 'Kode QR untuk aplikasi autentikator Anda',
  'auth.2fa.manualKey': 'Tidak bisa memindai? Masukkan kunci ini di aplikasi:',
  'auth.2fa.turnOn': 'Aktifkan',
  'auth.2fa.working': 'Menyimpan…',
  'auth.2fa.recoveryTitle': 'Simpan kode pemulihan Anda',
  'auth.2fa.recoveryIntro': 'Kalau HP Anda hilang, setiap kode bisa dipakai sekali untuk masuk. Kode hanya ditampilkan sekarang: salin atau unduh, lalu simpan di tempat yang aman.',
  'auth.2fa.copy': 'Salin',
  'auth.2fa.copied': 'Tersalin',
  'auth.2fa.download': 'Unduh',
  'auth.2fa.saved': 'Sudah saya simpan, lanjut',
  'auth.2fa.panelTitle': 'Verifikasi dua langkah',
  'auth.2fa.panelHint': 'Kode dari HP setiap kali masuk, selain kata sandi.',
  'auth.2fa.statusOn': 'Aktif · sisa {count} kode pemulihan',
  'auth.2fa.statusOff': 'Nonaktif',
  'auth.2fa.statusRequired': 'Wajib untuk semua staf console.',
  'auth.2fa.setUp': 'Aktifkan',
  'auth.2fa.turnOff': 'Matikan',
  'auth.2fa.turnOffHint': 'Masukkan kode saat ini atau kode pemulihan untuk mematikannya. Mau pindah ke HP baru? Matikan dulu, lalu aktifkan lagi.',
  'auth.2fa.turnedOn': 'Verifikasi dua langkah sudah aktif.',
  'auth.2fa.turnedOff': 'Verifikasi dua langkah sudah dimatikan.',
  'auth.2fa.cancel': 'Batal',
  'auth.2fa.banner': 'Verifikasi dua langkah segera wajib untuk semua staf console. Aktifkan sekarang, cuma butuh semenit.',
  'auth.2fa.bannerAction': 'Aktifkan',
  'staff.2fa.on': '2 langkah aktif',
  'staff.2fa.reset': 'Reset 2 langkah',
  'staff.2fa.resetTitle': 'Reset verifikasi dua langkah untuk {name}?',
  'staff.2fa.resetBody': 'Aplikasi autentikator dan kode pemulihannya tidak berlaku lagi. Dia mengaktifkannya lagi saat masuk berikutnya.',
  'staff.2fa.resetDone': 'Verifikasi dua langkah sudah direset.',
  'staff.central.title': 'Akun Digimasi: reset verifikasi dua langkah',
  'staff.central.hint': 'Untuk orang yang masuk lewat admin.digimasi.com dan kehilangan HP serta kode pemulihannya. Admin website tidak bisa mereset kalau orang itu juga memakai website Digimasi lain; Anda bisa, di sini. Pastikan dulu Anda bicara dengan orang yang benar.',
  'staff.central.email': 'Email akun Digimasi',
  'staff.central.submit': 'Reset verifikasi dua langkah',
  'staff.central.confirmTitle': 'Reset verifikasi dua langkah untuk {email}?',
  'staff.central.confirmBody': 'Aplikasi autentikator dan kode pemulihannya tidak berlaku lagi di semua website Digimasi. Dia mengaktifkannya lagi saat masuk berikutnya.',
  'staff.central.done': 'Sudah direset. {email} mengaktifkannya lagi saat masuk berikutnya.',
  'staff.central.nothing': '{email} belum memakai verifikasi dua langkah. Tidak ada yang berubah.',
  'audit.action.auth.login_password': 'Kata sandi benar, lanjut kode',
  'audit.action.auth.2fa_failed': 'Kode dua langkah salah',
  'audit.action.auth.2fa_recovery_used': 'Masuk dengan kode pemulihan',
  'audit.action.auth.2fa_setup': 'Mengaktifkan verifikasi dua langkah',
  'audit.action.auth.2fa_disabled': 'Mematikan verifikasi dua langkah',
  'audit.action.staff.2fa_reset': 'Mereset verifikasi dua langkah staf',
  'audit.action.account.2fa_reset': 'Mereset verifikasi dua langkah akun Digimasi',
}
